/* Purry Home — region-aware copy.
   The shop sells to the UK, the US and the EU from one storefront. Copy is
   written for the UK; for shoppers elsewhere the phrases below are swapped
   inside any element marked data-ph-geo. The region comes from, in order: the
   market country Shopify rendered the page in (data-ph-market on <html>), a
   cached answer from this session, or Shopify's own geolocation endpoint
   (/browsing_context_suggestions.json), so no third-party service is used.
   Supported regions: UK (default), US, DE, FR, NL, ES. Any other country reads
   the UK copy. The swaps are English phrases, so they only run on English pages:
   the de/fr/nl/es storefronts carry their own wording in the locale files. */
(() => {
  const html = document.documentElement;
  const ENGLISH = /^en\b/i.test(html.lang || 'en');
  // name: how the country is written mid-sentence; delivery: the trust/promise line;
  // socket / electrician: the wiring phrases.
  // the: how "the UK" reads ("across the UK" → "across Germany" / "across the Netherlands").
  const REGIONS = {
    US: { name: 'US', the: 'the US', delivery: 'Free US delivery', socket: 'standard US outlet', electrician: 'licensed electrician' },
    DE: { name: 'Germany', the: 'Germany', delivery: 'Free delivery to Germany', socket: 'standard European socket', electrician: 'qualified electrician' },
    FR: { name: 'France', the: 'France', delivery: 'Free delivery to France', socket: 'standard European socket', electrician: 'qualified electrician' },
    NL: { name: 'the Netherlands', the: 'the Netherlands', delivery: 'Free delivery to the Netherlands', socket: 'standard European socket', electrician: 'qualified electrician' },
    ES: { name: 'Spain', the: 'Spain', delivery: 'Free delivery to Spain', socket: 'standard European socket', electrician: 'qualified electrician' },
  };
  const rulesFor = (r) => [
    [/Free UK delivery/g, r.delivery],
    [/qualified electrician/g, r.electrician],
    [/standard UK socket/g, r.socket],
    [/\b[Tt]he UK\b/g, r.the],
    [/\bUK\b/g, r.name],
  ];
  let RULES = [];
  const swapText = (s) => RULES.reduce((t, [re, to]) => t.replace(re, to), s);
  function swapIn(root) {
    if (root.dataset.phGeoDone) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((n) => { const t = swapText(n.nodeValue); if (t !== n.nodeValue) n.nodeValue = t; });
    root.querySelectorAll('[title],[aria-label],[placeholder]').forEach((el) => {
      ['title', 'aria-label', 'placeholder'].forEach((a) => { const v = el.getAttribute(a); if (v) { const t = swapText(v); if (t !== v) el.setAttribute(a, t); } });
    });
    root.dataset.phGeoDone = '1';
  }
  function apply(region) {
    html.dataset.phRegion = region;
    if (REGIONS[region] && ENGLISH) {
      RULES = rulesFor(REGIONS[region]);
      document.querySelectorAll('[data-ph-geo]').forEach(swapIn);
    }
    document.dispatchEvent(new CustomEvent('ph:region', { detail: region }));
  }
  const normalise = (code) => (REGIONS[code] ? code : 'UK');
  function detect() {
    const market = (html.dataset.phMarket || '').toUpperCase();
    if (REGIONS[market]) return apply(market);
    let cached = null;
    try { cached = sessionStorage.getItem('ph_region'); } catch (e) { /* private mode */ }
    if (cached && (cached === 'UK' || REGIONS[cached])) return apply(cached);
    fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then((r) => r.json())
      .then((j) => {
        const c = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
        const region = normalise(String(c || '').toUpperCase());
        try { sessionStorage.setItem('ph_region', region); } catch (e) { /* ignore */ }
        apply(region);
      })
      .catch(() => apply('UK'));
  }
  // Sections Shopify re-renders later (cart drawer, section rendering API) get the swap too.
  const mo = new MutationObserver(() => { if (ENGLISH && REGIONS[html.dataset.phRegion]) document.querySelectorAll('[data-ph-geo]:not([data-ph-geo-done])').forEach(swapIn); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', detect); else detect();
  mo.observe(document.body || html, { childList: true, subtree: true });
})();
